// Apollo
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { toIdValue } from "apollo-utilities";
import { createUploadLink } from "apollo-upload-client";
import { onError } from "apollo-link-error";
import { setContext } from "apollo-link-context";
import { createHttpLink } from "apollo-link-http";
import BaseUrlConstants from "../constants/BaseUrlConstants";
import { getAuthToken } from "../contexts/AuthContext";

let AUTH_TOKEN: string | null = null;

// Cache Apollo
const cache: any = new InMemoryCache({
    cacheRedirects: {
        Query: {
            user: (_, { id }) =>
                toIdValue(cache.config.dataIdFromObject({ __typename: "User", id })),
        },
    },
});

// --- 🔐 Authentification standard (backoffice) ---
const httpLink = createHttpLink({
    uri: BaseUrlConstants.BASE_URL + "graphql/",
});

const uploadLink = createUploadLink({
    uri: BaseUrlConstants.BASE_URL + "graphql/",
}) as any;

// 🔧 On revient à l’en-tête attendu par Symfony : X-Auth-Token
const authLink = setContext((_, { headers }) => {
    const token = getAuthToken()?.value;
    return {
        headers: {
            ...headers,
            "X-Auth-Token": token ?? null,
        },
    };
});

const loggOutAfterware = onError(({ graphQLErrors }) => {
    if (!graphQLErrors) return;
    const unauth = graphQLErrors.find((error: any) => error.unauthenticated);
    if (unauth) {
        console.warn("🔒 Session expirée ou token invalide.");
    }
});

// Client principal (utilisateurs connectés)
const client = new ApolloClient({
    link: loggOutAfterware.concat(authLink).concat(uploadLink).concat(httpLink),
    cache,
});

function updateAuthToken(authToken: any) {
    AUTH_TOKEN = authToken;
}

// --- 🌐 Client public (menu-client) ---
const publicAuthLink = setContext((_, { headers }) => {
    // On lit le token directement dans l’URL (ex: ?token=xxxx)
    const params = new URLSearchParams(window.location.hash.split("?")[1]);
    const token = params.get("token");

    return {
        headers: {
            ...headers,
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
    };
});

const publicHttpLink = createHttpLink({
    uri: BaseUrlConstants.BASE_URL + "graphql/public",
});

const publicClient = new ApolloClient({
    link: publicAuthLink.concat(publicHttpLink),
    cache: new InMemoryCache(),
});

export { client, publicClient, updateAuthToken };
